import gql from 'graphql-tag';

export default gql(`
  query ($serviceUuid: String!) {
    Members(filters: {
      supply: $serviceUuid
    }) {
      uuid
      avatar
      lastname
      firstname
      comment
      phone
      mobile
      email
      address {
        city
        zipcode
      }
    }
  }
`);



// WEBPACK FOOTER //
// ./src/api/query/Members.js